module.exports = __webpack_public_path__ + "resources/img/logo_entermate_m.0d724764148baea42f51c51e8f4b5fec.png";